import { ExhibitorsValidationResult } from "ts/app/exhibitorsBulkUpload";

export enum ExhibitorImportProgress {
  FILE_UPLOAD = 0,
  REVIEW,
}

export enum ExhibitorCsvUploadProgress {
  TEMPLATE_DOWNLOAD = 0,
  CSV_UPLOAD,
}

export type ExhibitorsCsvFileStatus =
  | "no-file-uploaded"
  | "valid-csv"
  | "missing-required-fields"
  | "invalid-build-type";

export type ExhibitorImportStatus = {
  exhibitorImportProgress: ExhibitorImportProgress;
  csvUploadProgress: ExhibitorCsvUploadProgress;
  exhibitorsCsvFileStatus: ExhibitorsCsvFileStatus;
  exhibitorsValidationResult: ExhibitorsValidationResult | null;
};
